import { render, staticRenderFns } from "./RiskToggleMenu.vue?vue&type=template&id=7dd494ab&"
import script from "./RiskToggleMenu.vue?vue&type=script&lang=js&"
export * from "./RiskToggleMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports